import React from 'react';
import { Container } from 'react-bootstrap';

const fitSignals = [
  'Legacy distributors with decades of operating knowledge, customer trust, and untapped digital leverage',
  'CPG companies managing fragmented channels, messy catalogs, and manual marketplace workflows',
  'Family businesses where modernization has to respect the people who built the company',
  'Teams still running critical work through spreadsheets, email, manual entry, and disconnected systems',
  'Operators who need practical ROI, not AI theater or a deck that never becomes a working system'
];

const FitSection = () => {
  return (
    <section className="wn-section wn-fit-section" id="fit">
      <Container>
        <div className="wn-fit-layout">
          <div className="wn-fit-copy wn-fade-in">
            <div className="wn-section-label">
              <span className="label-dot" />
              Who This Is For
            </div>
            <h2 className="wn-section-title">
              Built for businesses that know they need to modernize, but cannot
              afford a failed tech project.
            </h2>
            <p className="wn-section-subtitle">
              If your business has the relationships, inventory, and operating
              muscle, but lacks the AI and ecommerce infrastructure to compete
              in the next decade, that is exactly where we come in.
            </p>
            <a
              href="#contact"
              className="wn-btn-primary wn-fit-cta"
              onClick={e => {
                e.preventDefault();
                document
                  .getElementById('contact')
                  ?.scrollIntoView({ behavior: 'smooth' });
              }}
            >
              Book a Free Automation &amp; Ecommerce Assessment →
            </a>
          </div>

          <div className="wn-fit-list wn-fade-in wn-fade-in-delay-1">
            {fitSignals.map((item, i) => (
              <div className="wn-fit-item" key={i}>
                <span className="wn-fit-index">
                  {String(i + 1).padStart(2, '0')}
                </span>
                <p>{item}</p>
              </div>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
};

export default FitSection;
